import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
import { Button } from './button';

const BaseButtonGroup = styled.div<{
  $space?: number;
  $reversed?: boolean;
  $vertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $reversed = false, $vertical = false }) =>
    `${$vertical ? 'column' : 'row'}${$reversed ? '-reverse' : ''}`};
  gap: ${({ $space: $size = 16 }) => `${$size}px`};

  ${Button} {
    flex: 1;
    &.ant-btn-icon-only,
    &.rl-btn-only-icon {
      flex-grow: 0;
    }
  }
`;

export const ButtonGroup = withHideIfNotAllowed(BaseButtonGroup);
